module.exports = __webpack_public_path__ + "media/images/ipaf_1b-176829c72b0c3dcfd9d01743f1b3ad19.png";